export default "__VITE_ASSET__444296f9__"